import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import consola from '../njs/consola.js'

export default ({ app }) => {
  Sentry.init({
    dsn: 'https://df31d7af81c44f35ab8f9aa4d4dcddb4@o224866.ingest.sentry.io/5829114',
    release: 'win-b2b-goodwin-dealer@1.0.0',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.1
  })

  app.config.errorHandler = (err, _vm, info) => {
    consola.error(info, err)
    Sentry.captureException(err)
  }

  window.addEventListener('error', event => {
    consola.error(event)
    Sentry.captureException(event)
  })
  window.addEventListener('unhandledrejection', event => {
    consola.error(event)
    Sentry.captureException(event)
  })
}
